<template>
 <div class="footer">
     <div class="footer_text">
         CNODE社区
     </div>
 </div>
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>

<style scoped>
.footer{
    background:#fff;
    margin-top:30px;
    padding:20px;
}
.footer .footer_text {
    text-align: center;
    color:#7fbd00;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue